import { cn } from "../../utils/classnames"

export type AcknowledgedFilter = "new" | "reviewed" | "all"

interface Props {
  acknowledgedFilter: AcknowledgedFilter
  onAcknowledgedFilterChange: (filter: AcknowledgedFilter) => void
  unacknowledgedCount?: number
}

const ACKNOWLEDGED_TABS: { id: AcknowledgedFilter; label: string }[] = [
  { id: "new", label: "New" },
  { id: "reviewed", label: "Reviewed" },
  { id: "all", label: "All" }
]

const CategoryFilterBar = ({
  acknowledgedFilter,
  onAcknowledgedFilterChange,
  unacknowledgedCount
}: Props) => {
  return (
    <div className="flex flex-wrap items-center gap-4">
      <div className="flex rounded-lg border border-neutral-200 bg-neutral-50 p-0.5">
        {ACKNOWLEDGED_TABS.map(tab => {
          const isActive = acknowledgedFilter === tab.id
          return (
            <button
              key={tab.id}
              type="button"
              onClick={() => onAcknowledgedFilterChange(tab.id)}
              className={cn(
                "rounded-md px-3 py-1.5 text-sm font-medium transition-all",
                isActive
                  ? "bg-white text-neutral-800 shadow-sm"
                  : "text-neutral-500 hover:text-neutral-700"
              )}
            >
              {tab.label}
              {tab.id === "new" &&
                unacknowledgedCount != null &&
                unacknowledgedCount > 0 && (
                  <span className="ml-1.5 inline-flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-primary-400 px-1 text-[10px] font-bold text-white">
                    {unacknowledgedCount}
                  </span>
                )}
            </button>
          )
        })}
      </div>
    </div>
  )
}

export default CategoryFilterBar
